/**
 * Экранная клавиатура телефона.
 *
 * Пока человек печатает, клавиатура съедает половину экрана. Шторки
 * (выбор монеты, индикаторы, боты) стоят на нижней панели разделов и
 * занимают три четверти высоты — с клавиатурой от них оставалась
 * полоска, а панель разделов всплывала поверх неё и закрывала список:
 * монета находилась («Инструментов: 2»), но её не было видно.
 *
 * Здесь только признак и размеры: на корне страницы класс `kb-open`,
 * пока в поле ввода стоит курсор на сенсорном экране, и переменные
 * `--vv-top` / `--vv-h` — видимая над клавиатурой часть экрана. Что с
 * этим делать, решает CSS: панель разделов прячется, шторка встаёт на
 * всю видимую часть.
 */

const TEXT_TYPES = new Set(['text', 'search', 'email', 'number', 'tel', 'url', 'password', '']);

function isTextEntry(node: EventTarget | null): boolean {
  if (!(node instanceof HTMLElement)) return false;
  if (node instanceof HTMLTextAreaElement) return true;
  if (node instanceof HTMLInputElement) return TEXT_TYPES.has(node.type);
  return node.isContentEditable;
}

export function watchKeyboard(): void {
  // Клавиатуру поднимает палец: мышь и настоящая клавиатура экран не отнимают.
  if (globalThis.matchMedia?.('(pointer: coarse)').matches !== true) return;
  const root = document.documentElement;
  const viewport = window.visualViewport;

  const measure = (): void => {
    const height = viewport?.height ?? window.innerHeight;
    const top = viewport?.offsetTop ?? 0;
    root.style.setProperty('--vv-h', `${Math.round(height)}px`);
    root.style.setProperty('--vv-top', `${Math.round(top)}px`);
  };

  document.addEventListener('focusin', (event) => {
    if (!isTextEntry(event.target)) return;
    measure();
    root.classList.add('kb-open');
  });
  document.addEventListener('focusout', () => {
    // Курсор мог перейти в соседнее поле — тогда клавиатура не закрывается.
    window.setTimeout(() => {
      if (!isTextEntry(document.activeElement)) root.classList.remove('kb-open');
    }, 60);
  });
  viewport?.addEventListener('resize', measure);
  viewport?.addEventListener('scroll', measure);
  measure();
}
